import {
  Drawer,
  DrawerBodyProps,
  DrawerOverlayProps,
  DrawerProps,
} from "@mantine/core"
import { ReactNode } from "react"

import { IconDrawerClose } from "~/assets/icons/IconDrawerClose"

type Props = {
  children: ReactNode
  size?: string
  onClose: () => void
  onOpen?: () => void
  opened: boolean
  title?: string
  bg?: string
  overlayProps?: DrawerOverlayProps
  drowerBodyProps?: DrawerBodyProps
} & DrawerProps
export function CustomDrawer({
  children,
  size,
  onClose,
  opened,
  title,
  bg,
  overlayProps = { backgroundOpacity: 0.5 },
  drowerBodyProps = {},
  ...props
}: Props) {
  return (
    <Drawer.Root
      opened={opened}
      onClose={onClose}
      position="right"
      size={size}
      {...props}
    >
      <Drawer.Overlay {...overlayProps} />
      <Drawer.Content p={0} bg={bg} h="100vh">
        <Drawer.Header
          p={0}
          bd="1px solid var(--mantine-color-gray-3)"
          pos="relative"
          top={0}
          mih="5%"
        >
          <Drawer.CloseButton
            icon={
              <IconDrawerClose size={20} color="var(--mantine-color-gray-6)" />
            }
            style={{
              marginInlineStart: "20px",
            }}
          />
          {title && <Drawer.Title>{title}</Drawer.Title>}
        </Drawer.Header>
        <Drawer.Body p={0} h="95%" {...drowerBodyProps}>
          {children}
        </Drawer.Body>
      </Drawer.Content>
    </Drawer.Root>
  )
}
